import { storage } from '@/services/storage'

export const NPS = {
	namespaced: true,

	state: {
		data: null,
	},

	getters: {
		getNPSConfig(state) {
			return state.data
		},
	},

	mutations: {
		SYNC_NPS_CONFIG(state, payload) {
			const config = storage.get('nps_' + payload.nps_user_identity)
				? JSON.parse(storage.get('nps_' + payload.nps_user_identity))
				: null
			state.data = config
		},

		SET_NPS_CONFIG(state, payload) {
			state.data = { ...payload }
			if(payload?.nps_user_identity) {
				storage.set('nps_' + payload.nps_user_identity, JSON.stringify(state.data))
			}
		},
	},

	actions: {
		syncNPSConfig({ commit }, payload) {
			commit('SYNC_NPS_CONFIG', payload)
		},

		setNPSConfig({ commit }, payload) {
			commit('SET_NPS_CONFIG', payload)
		},
	},
}
